import React from 'react';
import { Box } from '@mui/material';

const asArray = (sx) => (Array.isArray(sx) ? sx : [sx]);

// Consume legacy Grid props while preserving the pages' values and conditions.
export default function SummaryStrip({
  children, sx, className = '', container, spacing, rowSpacing, columnSpacing, columns, ...props
}) {
  return (
    <Box component="section" aria-label="Summary" {...props}
      className={`workspace-summary ${className}`}
      sx={[
        ...asArray(sx),
        {
          display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(4, minmax(0, 1fr))' },
          gap: 2, width: '100%', minWidth: 0, mb: 3, alignItems: 'stretch',
          '& > .MuiGrid-root': { width: 'auto', maxWidth: 'none', minWidth: 0, p: 0, m: 0, display: 'flex', flexDirection: 'column' },
          '& > .MuiGrid-root > *': { flexGrow: 1 },
          '& .MuiCardContent-root, & .MuiCardContent-root:last-child': { p: 0 },
          '& .MuiAvatar-root': { width: 36, height: 36, borderRadius: '10px', flexShrink: 0, order: -1 },
          '& .MuiAvatar-root .MuiSvgIcon-root': { fontSize: 20 },
          '& .MuiStack-root': { gap: 1.5, '& > :not(style) ~ :not(style)': { ml: 0 } },
          '& .MuiStack-root > .MuiBox-root': { minWidth: 0 },
          '& .MuiTypography-root': { overflowWrap: 'anywhere', fontVariantNumeric: 'tabular-nums' },
          '& .MuiTypography-h3, & .MuiTypography-h4, & .MuiTypography-h5': {
            fontSize: { xs: '1.5rem', sm: '1.625rem' }, fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.025em',
          },
          '& .MuiTypography-h6': { fontSize: '0.8125rem', fontWeight: 500, lineHeight: 1.5, color: 'text.secondary' },
          '& .MuiTypography-noWrap': { whiteSpace: 'normal', overflow: 'visible', textOverflow: 'clip' },
        },
      ]}
    >{children}</Box>
  );
}

export function SummaryMetric({ children, onClick, onKeyDown, elevation, variant, className = '', sx, ...props }) {
  return (
    <Box role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} {...props}
      onClick={onClick}
      onKeyDown={(event) => {
        onKeyDown?.(event);
        if (onClick && !event.defaultPrevented && event.target === event.currentTarget && ['Enter', ' '].includes(event.key)) {
          event.preventDefault();
          event.currentTarget.click();
        }
      }}
      className={`workspace-metric ${className}`}
      sx={[
        ...asArray(sx),
        (theme) => ({
          minWidth: 0, width: '100%', height: '100%', minHeight: 108, p: 2.25, m: 0,
          background: theme.palette.background.paper, color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`, borderRadius: '14px',
          boxShadow: theme.palette.mode === 'dark' ? '0 1px 3px rgba(0,0,0,0.12)' : '0 1px 3px rgba(15,23,42,0.04)',
          transition: 'border-color 150ms ease, background-color 150ms ease',
          '&:hover': { boxShadow: 'none', transform: 'none', ...(onClick ? { borderColor: 'primary.main', bgcolor: 'action.hover' } : {}) },
          '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 },
        }),
      ]}
    >{children}</Box>
  );
}
